(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-overlay')) {
    customElements.define(
      'search-overlay',
      class SearchOverlay extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.input = this.querySelector('input[type="search"]');
          this.form = this.querySelector('form');
          this.openers = document.querySelectorAll('[data-search-overlay-open]');
          this.closeButton = this.querySelector('[data-search-overlay-close]');
          this.open = this.open.bind(this);
          this.close = this.close.bind(this);

          this.openers.forEach((opener) => opener.addEventListener('click', this.open));
          this.closeButton.addEventListener('click', this.close);
          this.dialog.addEventListener('close', this.onClose.bind(this));
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.addEventListener('click', this.onInitialTabClick.bind(this));
        }

        onInitialTabClick(event) {
          const tabButton = event.target.closest('[data-predictive-tab]');
          if (!tabButton) return;

          const wrapper = tabButton.closest('.search-overlay__initial');
          if (!wrapper) return;

          wrapper.setAttribute('data-active-tab', tabButton.dataset.predictiveTab);
          wrapper.querySelectorAll('[data-predictive-tab]').forEach((button) => {
            button.setAttribute('aria-selected', button === tabButton);
          });
        }

        open(event) {
          event.preventDefault();
          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('search-overlay-open');
          this.updateTopOffset();
          requestAnimationFrame(() => this.input.focus());
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        onClose() {
          document.documentElement.classList.remove('search-overlay-open');
        }

        updateTopOffset() {
          const topbar = this.querySelector('.search-overlay__topbar');
          this.style.setProperty('--search-overlay-top', `${topbar.offsetHeight}px`);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
